(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kumm-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kumm-navigation')) {
  customElements.define('kumm-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.nav = this.querySelector('.kk-nav');
      this.host = this.querySelector('.kk-nav-host');
      this.mobileTitle = this.nav.querySelector('.kk-mobile-head strong');
      this.defaultTitle = this.mobileTitle?.textContent;
      this.dialog = this.querySelector('.kk-dialog');
      this.backdrop = this.querySelector('.kk-backdrop');
      this.details = [...this.querySelectorAll('.kk-details')];
      this.mobile = matchMedia('(max-width: 1023px)');
      this.hoverCapable = matchMedia('(hover: hover) and (pointer: fine)');
      this.trigger = this.closest('header').querySelector('[data-kk-toggle]');
      this.dialog.id = 'KummDialog-' + this.dataset.section;
      this.trigger?.setAttribute('aria-controls', this.dialog.id);
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.trigger?.addEventListener('click', () => {
        this.lastFocus = document.activeElement;
        this.dialog.showModal();
        this.dialog.scrollTop = 0;
        this.oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.trigger.setAttribute('aria-expanded', 'true');
        this.nav.querySelector('[data-kk-close]').focus();
      }, {signal});
      this.nav.querySelector('[data-kk-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.oldOverflow ?? '';
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.closePanels();
        this.lastFocus?.focus();
      }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right) this.dialog.close();
        }
      }, {signal});
      this.details.forEach(detail => {
        const summary = detail.querySelector('summary');
        const mobileButton = detail.parentElement.querySelector('[data-kk-section-toggle]');
        detail.mobileButton = mobileButton;
        summary.setAttribute('aria-expanded', 'false');
        mobileButton.addEventListener('click', () => {
          this.hoverOpened = null;
          this.closePanels(detail);
          detail.open = true;
          this.sync();
          detail.querySelector('[data-kk-back]').focus({preventScroll: true});
          this.dialog.scrollTop = 0;
        }, {signal});
        summary.addEventListener('click', event => {
          // Let the browser perform the mobile disclosure's single activation.
          if (this.mobile.matches) return;
          event.preventDefault();
          // The first click keeps a panel opened by hover; later clicks toggle it.
          const opening = !detail.open || this.hoverOpened === detail;
          this.hoverOpened = null;
          this.closePanels(detail);
          detail.open = opening;
          this.sync();
        }, {signal});
        detail.querySelectorAll('[data-kk-back]').forEach(button => button.addEventListener('click', () => {
          this.hoverOpened = null;
          detail.open = false;
          this.sync();
          (this.mobile.matches ? mobileButton : summary).focus({preventScroll: true});
          if (this.mobile.matches) this.dialog.scrollTop = 0;
        }, {signal}));
        detail.addEventListener('pointerenter', event => {
          if (this.mobile.matches || !this.hoverCapable.matches || event.pointerType !== 'mouse' || this.closest('header').dataset.kkTrigger !== 'hover') return;
          clearTimeout(this.leaveTimer);
          if (detail.open) return;
          this.enterTimer = setTimeout(() => {
            this.closePanels(detail);
            detail.open = true;
            this.hoverOpened = detail;
            this.sync();
          }, 180);
        }, {signal});
        detail.addEventListener('pointerleave', () => clearTimeout(this.enterTimer), {signal});
      });
      this.nav.addEventListener('pointerleave', () => {
        clearTimeout(this.enterTimer);
        if (!this.mobile.matches && !this.nav.contains(document.activeElement)) this.leaveTimer = setTimeout(() => this.closePanels(), 280);
      }, {signal});
      this.nav.addEventListener('pointerenter', () => clearTimeout(this.leaveTimer), {signal});
      this.nav.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const opened = this.details.find(detail => detail.open);
        if (opened) {
          event.preventDefault(); event.stopPropagation();
          this.closePanels();
          (this.mobile.matches ? opened.mobileButton : opened.querySelector('summary')).focus({preventScroll: true});
          if (this.mobile.matches) this.dialog.scrollTop = 0;
        }
      }, {signal});
      document.addEventListener('click', event => {
        if (!this.mobile.matches && !this.contains(event.target)) this.closePanels();
      }, {signal});
      document.addEventListener('focusin', event => {
        if (!this.mobile.matches && !this.contains(event.target)) this.closePanels();
      }, {signal});
      this.backdrop.addEventListener('click', () => this.closePanels(), {signal});
      this.mobile.addEventListener('change', () => this.layout(), {signal});
      this.layout();
    }
    layout() {
      if (this.dialog.open) this.dialog.close();
      this.closePanels();
      (this.mobile.matches ? this.dialog : this.host).append(this.nav);
    }
    closePanels(except) {
      clearTimeout(this.enterTimer); clearTimeout(this.leaveTimer);
      if (this.hoverOpened !== except) this.hoverOpened = null;
      this.details.forEach(detail => { if (detail !== except) detail.open = false; });
      this.sync();
    }
    sync() {
      const opened = this.details.find(detail => detail.open);
      const title = opened?.querySelector('summary span')?.textContent || this.defaultTitle;
      if (this.mobileTitle && this.mobileTitle.textContent !== title) this.mobileTitle.textContent = title;
      this.details.forEach(detail => {
        detail.querySelector('summary').setAttribute('aria-expanded', String(detail.open));
        detail.mobileButton.setAttribute('aria-expanded', String(detail.open));
      });
      this.backdrop.hidden = this.mobile.matches || !this.details.some(detail => detail.open);
    }
    disconnectedCallback() {
      clearTimeout(this.enterTimer); clearTimeout(this.leaveTimer);
      if (this.dialog?.open) { this.dialog.close(); document.body.style.overflow = this.oldOverflow ?? ''; }
      this.controller?.abort(); this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
